import Snackbar from '../components/snackbars/snackbar';
import { findChildComponents } from '../utils/helpers'

export default function (Vue, options) {

  const SNACK_CONSTRUCTOR = Vue.extend(Snackbar);
  const _queue = []

  class Toaster {

    constructor() {
      this.onToastClosed = this.onToastClosed.bind(this)
      this._appRouter = null
      this._appi18n = null
    }

    /**
     * Toaster needs a reference to the router instance being used by the application, so it can
     * properly instantiate components that contains `<router-link>` components.
     */
    set router(router) {
      this._appRouter = router
    }

    /**
     * Toaster needs a reference to the i18n plugin instance being used by the application, so it can
     * properly instantiate components that contains `$t` translation calls.
     */
    set i18n(i18n) {
      this._appi18n = i18n
    }

    /**
     * Adds a toast message to the root app element 
     * @param  {String} message   A string that will be used as the toast's content.
     * @param  {Object} options   Props to be used on the toast component.
     */
    show(message, options = {}) {
      let optionsData = Object.assign({message}, options)      
      return this._show(SNACK_CONSTRUCTOR, optionsData, options.parent)
    }

    /**
     * Adds a user defined component to the root app element 
     * @param  {Object} constructorFn   A constructor function for a Vue component. The component
     *                                  must use the "toggleable" mixin to function correctly.
     * @param  {Object} options         Props to be used on the component.
     */
    showInstance(constructorFn, options = {}) {
      return this._show(constructorFn, options, options.parent)
    }

    _show(constructorFn, props, parentComponent) {

      var closeCallback = this.onToastClosed

      var component = new constructorFn({
        router: this._appRouter,
        i18n: this._appi18n,
        propsData: props,
        mounted() { // Make sure component is mounted before we set its "isActive" value to true so intro animation works
          this.isActive = true

          if(props.tracking) {
            this.$nextTick(() => {
              let [context, value] = Object.entries(props.tracking)[0]
              this.$el.dataset.trackContext = context
              this.$el.dataset.trackValue = value
            })
          }
        },
        watch: { // when component is closed, clean up
          isActive(val) {
            if(val == false) closeCallback(this)
          }
        }
      })

      component.$mount();
      let container = document.body.querySelector('[data-app]');
      container.appendChild(component.$el);
      _queue.push(component);

      /**
       * If user has supplied a parent component, check if it contains any `n-page` components that
       * have a footer, and offset the toast's position accordingly.
       */
      if(parentComponent) {
        let pages = findChildComponents(parentComponent, child => child.$options._componentTag == 'n-page')
        let pageWithFooter = pages.find(page => page._displayFooter == true)
        this.offsetToastForFooter(pageWithFooter != null)
      }

      return component
    }

    onToastClosed(component) {
      setTimeout(() => {
        _queue.splice(_queue.indexOf(component), 1)

        component.$destroy(true);
        component.$el.parentNode.removeChild(component.$el);
      }, 500 /*wait for animation to finish*/);
    }

    offsetToastForFooter(hasFooter) {
      _queue.forEach(toast => toast.moveAboveFooter = hasFooter )
    }
  }

  Vue.prototype.$toaster = new Toaster();
}